<template>
  <LcHeader
    class="editor-header pb-100"
    left-button-icon="arrow-left"
    @left-button-click="emit('click:back')"
  >
    <template #headline>
      <slot name="headline">
        <LcLotteryLogo v-bind="{ licensedTerritory, lotteryId }" />
      </slot>
    </template>

    <template #right>
      <LcButton
        :aria-label="$t('info.header.infobutton.arialabel')"
        icon="info-help"
        size="small"
        variant="tertiary"
        @click="emit('click:info')"
      />
    </template>

    <slot />
  </LcHeader>
</template>

<script lang="ts" setup>
import { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

type Emits = {
  (e: 'click:back' | 'click:info'): void
}

type Props = { lotteryId: LotteryId }

const emit = defineEmits<Emits>()

const { lotteryId } = defineProps<Props>()

const licensedTerritory = useLicensedTerritory({ raw: true })
</script>

<style lang="scss" scoped>
.editor-header {
  /* stylelint-disable-next-line selector-class-pattern */
  :deep(.lc-header__wrap) {
    min-height: 4.5rem;
  }
}
</style>
